import Vue from 'vue'
import Vuex from 'vuex'

import App from './modules/App'
import Loader from './modules/Loader'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app: App,
    loader: Loader
  }
})



// WEBPACK FOOTER //
// ./src/vuex/Store.js